import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { memo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import {
  NotificationErrorVM,
  ProprietarioNotificaErrore,
} from 'practice/view-models/notification-error';
import NotificationErrorsTable from './table';

const AccordionNotificationErrorsComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const params = useParams();
  const castedParams = params as {
    codiceEnte: string;
    progressivoPratica: string;
    tipoRegistro: string;
    idAnnoPratica: string;
  };

  const [notifications, reload] = useHttpFetch<
    HttpResponseList<ProprietarioNotificaErrore>,
    NotificationErrorVM[]
  >(
    `${__PRACTICE_API_URL__}/proprietario/notifica-errore/${castedParams.codiceEnte}/${castedParams.idAnnoPratica}/${castedParams.tipoRegistro}/${castedParams.progressivoPratica}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        errorCatching: true,
        loading: true,
      },
      transformer: (response) => {
        return (response.data.payload.list || []).map((proprietario) => ({
          id: proprietario.key?.idProprietario?.toString() || '0',
          fiscalCode: proprietario.codFiscale || '',
          surname: proprietario.cognome || '',
          name: proprietario.nome || '',
          residence: proprietario.comune
            ? `${proprietario.comune}${
                proprietario.provincia ? ` (${proprietario.provincia})` : ''
              }`
            : '',
          proprietarioBE: proprietario,
        }));
      },
    }
  );

  const data = (notifications.data as NotificationErrorVM[]) || [];

  // L'accordion viene mostrato solo in presenza di proprietari con notifica in errore.
  if (!data.length) {
    return <></>;
  }

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-notification-errors-content"
        id="accordion-notification-errors-header"
        expandIcon={<ExpandMore />}
      >
        <Typography color="error" sx={{ fontWeight: 'bold' }}>
          Errori richieste di notifica
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <NotificationErrorsTable data={data} onReload={() => reload()} />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionNotificationErrorsComponent.displayName = 'Accordion Notification Errors';

const AccordionNotificationErrors = memo(AccordionNotificationErrorsComponent);

export default AccordionNotificationErrors;
